import { createApi } from '@reduxjs/toolkit/query/react'
import { HYDRATE } from 'next-redux-wrapper'

import { SanityQuery } from '~/redux/utils/sanity-query'

import { faqsQuery, getStaticPageQuery } from '~/shared/queries/staticPage'
import { AppLanguage } from '~/types/locale'

export const staticPageApi = createApi({
  reducerPath: 'staticPageApi',
  baseQuery: SanityQuery,
  tagTypes: ['staticPage'],
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath]
    }
  },
  endpoints: (builder) => ({
    getStaticPage: builder.query<
      { content: unknown[]; title: string; metaDescription: string; header: string },
      { language: string; path: string }
    >({
      query: (queryParams) => ({
        queryString: getStaticPageQuery,
        queryParams,
      }),
    }),
    // The faq static page in Sanity, with its list of contents projected as FAQs
    getFaqs: builder.query<
      {
        content: unknown[]
        title: string
        metaDescription: string
        header: string
        faqs: Array<{ question: string; answer: unknown[]; key: string }>
      },
      { language: AppLanguage }
    >({
      query: (queryParams) => ({
        queryString: faqsQuery,
        queryParams,
      }),
    }),
  }),
})

export const {
  useGetStaticPageQuery,
  useGetFaqsQuery,
  util: { getRunningQueriesThunk },
} = staticPageApi

export const { getStaticPage, getFaqs } = staticPageApi.endpoints
